// insert other default configuration
const config = { ...process.env }
export default config
